import React from 'react'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'
import Rollbar from 'rollbar'

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
  }

  constructor (props) {
    super(props)
    this.state = {
      rollbar: new Rollbar({
        accessToken: '92793af9e24e40a3a922256e03c99785',
        captureUncaught: true,
        captureUnhandledRejections: true,
        payload: {
          environment: process.env.NODE_ENV,
          person: {
            id: props.store.getState().user && props.store.getState().user.sub
          }
        }
      })
    }

    this.logInfo = this.logInfo.bind(this)
    this.throwError = this.throwError.bind(this)
  }

  logInfo (message) {
    this.state.rollbar.info(message)
  }

  throwError (message) {
    throw new Error(message)
  }

  shouldComponentUpdate () {
    return false
  }

  render () {
    return (
      <Provider store={this.props.store}>
        <div style={{ height: '100%' }}>
          <Router history={browserHistory} children={this.props.routes} />
        </div>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js